import React from 'react';

type PanelVariant = 'default' | 'strong' | 'sub';

interface PanelProps {
  children: React.ReactNode;
  variant?: PanelVariant;
  className?: string;
  as?: 'div' | 'section' | 'article';
}

const VARIANT_CLASS: Record<PanelVariant, string> = {
  default: 'glass-panel',
  strong: 'glass-panel-strong',
  sub: 'glass-sub-panel',
};

/**
 * Glass surface wrapper.
 * Drop-in replacement for the inline `LAYOUT.panel` / `LAYOUT.subPanel` styles
 * from design-tokens. Accepts any extra Tailwind utilities via `className`.
 */
export default function Panel({ children, variant = 'default', className = '', as = 'div' }: PanelProps) {
  const Tag = as;
  const combined = `${VARIANT_CLASS[variant]} ${className}`.trim();
  return <Tag className={combined}>{children}</Tag>;
}
